<template>
    <div class="container">
        <!-- <div class="jumbotron text-xs-center mt-4" v-show="!isFormMode">
            <h1 class="display-3">ขอบคุณ!</h1>
            <p class="lead"><strong>ขอบคุณสำหรับการลงทะเบียนสมาชิก Website Uptown Assets</strong> ทางเราจะติดต่อกลับโดยเร็วที่สุด</p>
            <hr>
            <p class="lead">
                <a class="btn btn-primary btn-sm" href="https://www.uptownassets.com/" role="button">กลับไปยังหน้าหลัก</a>
            </p>
        </div>         -->
        <div class="jumbotron text-xs-center mt-4" v-show="!isFormMode">
            <h1 class="display-3">Thank You!</h1>
            <p class="lead"><strong>Thank you for registering.</strong> We will get back to you as soon as possible.</p>
            <br />
            <p>Best Regards,</p>
            <p>Contact</p>
            <div class="row mb-2">
                <div class="col-2">Tel ::</div>
                <div class="col-10">
                    <div><a href="tel:064-569-3236">064 569 3236</a></div>
                    <div><a href="tel:061-624-7895">061 624 7895</a></div>
                    <div><a href="tel:088-264-9556">088 264 9556</a></div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-2">WhatsApp ::</div>
                <div class="col-10">
                    <div><a href="https://api.whatsapp.com/send?phone=+88645693236&text=Hi, I contacted you Through your website.">+88 64 569 3236</a></div>
                    <div><a href="https://api.whatsapp.com/send?phone=+88616247895&text=Hi, I contacted you Through your website.">+88 61 624 7895</a></div>
                    <div><a href="https://api.whatsapp.com/send?phone=+88882649556&text=Hi, I contacted you Through your website.">+88 88 264 9556</a></div>
                </div>
            </div>
            <div class="row mb-2">
                <div class="col-2">Line ::</div>
                <div class="col-10">@uptownassets</div>
            </div>
            <div class="row mb-2">
                <div class="col-2">E-mail ::</div>
                <div class="col-10">info@uptownassets.com</div>
            </div>
            <div class="row">
                <div class="col-2">Website ::</div>
                <div class="col-10">https://www.uptownassets.com</div>
            </div>            
            <hr>
            <p class="lead">
                <a class="btn btn-primary btn-sm" href="https://www.uptownassets.com/" role="button">Continue to homepage</a>
            </p>
        </div>
        <div class="row justify-content-center" v-show="isFormMode">
            <div class="col-md-8">
                <div class="card">
                    <header class="card-header bg-primary text-white">
                        <h4 class="card-title mt-2">
                            <img src="images/logo.png" alt="" width="45" height="45"/> 
                            <img src="images/logo-pf.jpg" alt="" height="45"/>
                            <hr />
                            ลงทะเบียน / Registration
                        </h4>
                    </header>
                    <article class="card-body">
                        <form>
                            <h5 class="pb-2">
                                <i class="fa fa-user-circle" aria-hidden="true"></i> ข้อมูลสมาชิก / Member Information
                            </h5>
                            <div class="form-row">
                                <div class="col-md-6 form-group required">
                                    <label class="control-label">ชื่อ / First name </label>   
                                    <input type="text" v-model="registerForm.first_name" class="form-control" :class="{'is-invalid': registerFormError.first_name}" placeholder="">
                                    <small class="text-danger" v-if="registerFormError.first_name">{{ registerFormError.first_name[0] }}</small>
                                </div> <!-- form-group end.// -->
                                <div class="col-md-6 form-group required">
                                    <label class="control-label">นามสกุล / Last name </label>
                                    <input type="text" v-model="registerForm.last_name" class="form-control" :class="{'is-invalid': registerFormError.last_name}" placeholder=" ">
                                    <small class="text-danger" v-if="registerFormError.last_name">{{ registerFormError.last_name[0] }}</small>
                                </div> <!-- form-group end.// -->
                            </div> <!-- form-row end.// -->
                            <div class="form-group">
                                <label>ประเภทความสนใจ / Type of Interest</label>
                                <div class="form-check-group">
                                    <label class="form-check">
                                        <input class="form-check-input" v-model="registerForm.type_of_interest" type="radio" name="type_of_interest" value="Owner Home">
                                        <span class="form-check-label"> เจ้าของบ้าน ฝากขาย ฝากเช่า / Unit Owner </span>
                                    </label>                                    
                                    <label class="form-check">
                                        <input class="form-check-input" v-model="registerForm.type_of_interest" type="radio" name="type_of_interest" value="Owner Room">
                                        <span class="form-check-label"> เจ้าของห้องชุด ฝากเช่า / Unit Owner </span>
                                    </label>
                                    <label class="form-check">
                                        <input class="form-check-input" v-model="registerForm.type_of_interest" type="radio" name="type_of_interest" value="Buyer">
                                        <span class="form-check-label"> ผู้สนใจซื้อ / Buyer</span>
                                    </label>                                    
                                    <label class="form-check">
                                        <input class="form-check-input" v-model="registerForm.type_of_interest" type="radio" name="type_of_interest" value="Renter">
                                        <span class="form-check-label"> ผู้สนใจเช่า / Renter</span>
                                    </label>
                                </div>
                                <div class="form-check-group pl-4" v-if="registerForm.type_of_interest === 'Renter'">
                                    <label class="form-check">
                                        <input class="form-check-input" :class="{'is-invalid': registerFormError.customer_status}" v-model="registerForm.customer_status" type="radio" name="customer_status" value="PF">
                                        <span class="form-check-label"> เป็นลูกค้า Property Perfect / Member of Property Perfect </span>
                                    </label>
                                    <label class="form-check">
                                        <input class="form-check-input" :class="{'is-invalid': registerFormError.customer_status}" v-model="registerForm.customer_status" type="radio" name="customer_status" value="NonPF">
                                        <span class="form-check-label"> ไม่เป็นลูกค้า Property Perfect / Non-member of Property Perfect</span>
                                    </label>
                                    <label class="form-check">
                                        <input class="form-check-input" :class="{'is-invalid': registerFormError.customer_status}" v-model="registerForm.customer_status" type="radio" name="customer_status" value="UnFixed">
                                        <span class="form-check-label"> ไม่ระบุ / Not Specific</span>
                                    </label>
                                    <small class="text-danger" v-if="registerFormError.customer_status && registerFormError.customer_status[0]">{{ registerFormError.customer_status[0] }}</small>                                                      
                                </div>                        
                            </div>
                            <div class="form-group">
                                <label>โครงการที่สนใจ / Interested Projects</label>
                                <i class="fa fa-refresh fa-spin fa-fw" aria-hidden="true" v-if="projects.length === 0"></i>
                                <v-select multiple v-model="registerForm.projects" :options="projects" :disabled="projects.length === 0"></v-select>  
                            </div> <!-- form-group end.// -->
                            <div class="form-group">
                                <label>รูปแบบห้อง / Room Type</label>
                                <i class="fa fa-refresh fa-spin fa-fw" aria-hidden="true" v-if="projects.length === 0"></i>
                                <v-select multiple v-model="registerForm.room_types" :options="roomTypes" :disabled="projects.length === 0"></v-select>  
                            </div> <!-- form-group end.// --> 
                            <div class="form-row">                   
                                <div class="col-lg-6 form-group required">
                                    <label class="control-label">หมายเลขโทรศัพท์ / Phone Number </label>
                                    <input v-model="registerForm.phone" type="text" class="form-control" :class="{'is-invalid': registerFormError.phone}" placeholder=" ">
                                    <small class="text-danger" v-if="registerFormError.phone">{{ registerFormError.phone[0] }}</small>
                                </div> <!-- form-group end.// -->
                                <div class="col-lg-6 form-group required">
                                    <label class="control-label">อีเมล์ / E-mail </label>
                                    <input v-model="registerForm.email" type="email" class="form-control" :class="{'is-invalid': registerFormError.email}" placeholder=" ">
                                    <small class="text-danger" v-if="registerFormError.email">{{ registerFormError.email[0] }}</small>
                                </div> <!-- form-group end.// -->   
                            </div>
                            <div class="form-row">  
                                <div class="col-md-6 form-group">
                                    <label>Line ID</label>
                                    <input v-model="registerForm.line" type="text" class="form-control" placeholder=" ">
                                </div> <!-- form-group end.// -->
                                <div class="col-md-6 form-group">
                                    <label>WhatsApp</label>
                                    <input v-model="registerForm.whatsapp" type="text" class="form-control" placeholder=" ">
                                </div> <!-- form-group end.// -->
                            </div>
                            <div class="form-row">  
                                <div class="col-md-6 form-group">
                                    <label>WeChat</label>
                                    <input v-model="registerForm.wechat" type="text" class="form-control" placeholder=" ">
                                </div> <!-- form-group end.// -->
                            </div>
                            <div class="form-row">
                                <div class="col form-group">
                                    <label>ได้รับข่าวสารจากแหล่งช่องทางใด / How did you hear about us?</label>
                                    <div class="form-check-group">
                                        <label class="form-check">
                                            <input class="form-check-input" v-model="registerForm.heardFrom" type="radio" name="heard_from" value="Website">
                                            <span class="form-check-label"> เว็บไซต์ / Website </span>
                                        </label>
                                        <label class="form-check">
                                            <input class="form-check-input" v-model="registerForm.heardFrom" type="radio" name="heard_from" value="Salesperson">
                                            <span class="form-check-label"> พนักงานขายโครงการ / Salesperson</span>
                                        </label>
                                        <label class="form-check">
                                            <input class="form-check-input" v-model="registerForm.heardFrom" type="radio" name="heard_from" value="Billboard">
                                            <span class="form-check-label"> ป้ายโฆษณา / Billboard</span>
                                        </label>
                                        <label class="form-check">
                                            <input class="form-check-input" v-model="registerForm.heardFrom" type="radio" name="heard_from" value="Leaflet">
                                            <span class="form-check-label"> ใบปลิว / Leaflet</span>
                                        </label>   
                                        <label class="form-check">
                                            <input class="form-check-input" v-model="registerForm.heardFrom" type="radio" name="heard_from" value="Others">
                                            <span class="form-check-label"> อื่นๆ / Others</span>
                                        </label>                                                                                                       
                                    </div>
                                </div> <!-- form-group end.// -->  
                            </div>                   
                            <div class="form-group">
                                <button type="submit" @click.prevent="saveRegistration(registerForm)" :disabled="loadSpinner" class="btn btn-primary btn-block">
                                    ลงทะเบียน / Register
                                    <i class="fa fa-refresh fa-spin fa-fw" aria-hidden="true" v-show="loadSpinner"></i>
                                </button>
                            </div> <!-- form-group// -->                      
                        </form>
                    </article> <!-- card-body end .// -->
                </div> <!-- card.// -->
            </div> <!-- col.//-->

        </div> <!-- row.//-->

    </div> 
    <!--container end.//-->
</template>

<script>
    export default {
        created() {
            this.getProjects();
        },
        methods: {
            getProjects: function () {
                let self = this;
                self.projects = [];
                axios.get('./projects-selection')
                .then(function (response) {
                    let projectData = response.data;
                    _.each(projectData, function(item) {
                        self.projects.push(item.project_name_th + ' / ' + item.project_name_en);
                    });
                    self.projects.push('อื่นๆ / Others');
                });
            },
            saveRegistration: function (registerForm) {
                let self = this;
                self.loadSpinner = true;
                axios.put('./registration', registerForm)
                .then(function (response) {
                    self.loadSpinner = false;
                    self.isFormMode = false;
                })
                .catch(function (error) {
                    self.loadSpinner = false;
                    self.registerFormError = error.response.data.errors;
                });                           
            }           
        },
        data: () => ({
            projects: [],
            registerForm: {},
            registerFormError: {},
            roomTypes: [
                'สตูดิโอ / Studio',
                '1 ห้องนอน / 1 Bedroom',
                '2 ห้องนอน / 2 Bedrooms',
                '3 ห้องนอน / 3 Bedrooms',
                'Moff 1 ห้องนอน / Moff 1 Bedroom',
                'Moff 2 ห้องนอน / Moff 2 Bedrooms',
                'Moff 3 ห้องนอน / Moff 3 Bedrooms',
                'Duplex 3 ห้องนอน / Duplex 1 Bedroom',
                'Duplex 3 ห้องนอน / Duplex 2 Bedrooms',
                'รวมห้องนอน 2 ห้องนอน / Combine 2 Bedrooms',
                'อื่นๆ / Others'
            ],
            loadSpinner: false,
            isFormMode: true
        })
    }
</script>



// WEBPACK FOOTER //
// resources/assets/js/components/frontend/RegisterComponent.vue